import { render, staticRenderFns } from "./ApiError.vue?vue&type=template&id=53c75fa4&scoped=true&"
var script = {}
import style0 from "./ApiError.vue?vue&type=style&index=0&id=53c75fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c75fa4",
  null
  
)

export default component.exports